/** @format */

import getRedirectionLink from '../../../utils/helper';
import { Link } from 'react-router-dom';
import { API_URL } from 'src/constants';

const InfoWidget = props => {
  const data = props.data;
  let image = API_URL + data.image;
  return (
    <div className={`info-widget`} data-width={data.w} data-height={data.h}>
      <img src={image} alt="card-icon" />
      <div className="card-title-outer">
        <h2 className={`card-title`}>{data.title}</h2>
      </div>
      {data?.link ? (
        <a href={getRedirectionLink(data)} target={`${data.linkTarget === '_blank' ? '_blank' : ''}`}>
          <p className="card-text">{data.linkTitle}</p>
        </a>
      ) : (
        <Link to={getRedirectionLink(data)}>
          <p className="card-text">{data.linkTitle}</p>
        </Link>
      )}
    </div>
  );
};

export { InfoWidget };
